import { UseFormReturn } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { FrUnassignCurrentUserUnitContainer } from './components/fr-unassign-current-user-unit-container';
import { useUnitDispositionContent } from '../fr-event-common-components/fr-disposition/hooks/use-unit-disposition-content';
import { FrDispositionPageContent } from '../fr-clear-event-page/components/fr-disposition-page-content';
import { useIntegratedForm } from '../forms/use-integrated-form';

export function FrUnassignCurrentUserUnitPage() {
    const {
        eventId,
        unitId,
        isPrimaryUnitForAssignedEvent,
        dispositionOptions,
        agencyId,
        agencyTypeGlobalAttrId,
        cautions,
        areCautionsLoading,
        eventLocation,
        eventForm,
    } = useUnitDispositionContent();
    const { query: eventQuery } = useIntegratedForm();

    if (eventQuery.isFetching) {
        return <LoadingIndicator />;
    }

    return (
        <FrUnassignCurrentUserUnitContainer eventId={eventId}>
            <FrDispositionPageContent
                isUnassignCurrentUserUnitPage
                primaryDispositionEditable={!!isPrimaryUnitForAssignedEvent}
                saveMutationErrorMsg="unassign myself"
                eventId={eventId}
                unitId={unitId}
                isPrimaryUnit={!!isPrimaryUnitForAssignedEvent}
                dispositionOptions={dispositionOptions}
                agencyId={agencyId}
                agencyTypeGlobalAttrId={agencyTypeGlobalAttrId}
                cautions={cautions}
                areCautionsLoading={areCautionsLoading}
                eventLocation={eventLocation}
                eventForm={(eventForm as unknown) as UseFormReturn<EventPanelFormType>}
            />
        </FrUnassignCurrentUserUnitContainer>
    );
}
